export const propertyFormFields = [
  ['name', 'Navn'],
  ['address', 'Adresse'],
  ['areaCode', 'Omradekode (4 siffer)'],
  ['size', 'Storrelse'],
  ['rooms', 'Soverom'],
  ['bathrooms', 'Bad'],
];

export const propertyTypeOptions = [
  { value: 'Hus', label: 'Hus' },
  { value: 'Leilighet', label: 'Leilighet' },
  { value: '2-mannsbolig', label: '2-mannsbolig' },
  { value: 'Tomt', label: 'Tomt' },
];

export const propertyAvailabilityOptions = [
  { value: 'ledig', label: 'Ledig' },
  { value: 'opptatt', label: 'Opptatt' },
];

export const settingsTextareaFields = [
  {
    field: 'heroTitle',
    label: 'Hero-tittel',
    rowsClassName: 'min-h-[100px]',
    transform: (value) => value,
    format: (value) => value,
  },
  {
    field: 'heroDescription',
    label: 'Hero-beskrivelse',
    rowsClassName: 'min-h-[120px]',
    transform: (value) => value,
    format: (value) => value,
  },
  {
    field: 'highlights',
    label: 'Highlights',
    rowsClassName: 'min-h-[120px]',
    transform: (value) => value.split('\n').filter(Boolean),
    format: (value) => value.join('\n'),
  },
];